import { type DefaultRootState } from 'react-redux';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const REDUCER_PREFIX = 'designerLocale';

type SliceState = {
  // Non-primary locale currently edited in the designer. Undefined = primary
  // (base) language, in which case no locale is sent to the experience API.
  viewLocale?: string;
  /** Editor to reopen after primary switch (Funnel remount closes open editors). */
  pendingStructuralEditor?: string;
};
const initialState: SliceState = {};

export const designerLocaleSlice = createSlice({
  name: REDUCER_PREFIX,
  initialState,
  reducers: {
    setDesignerViewLocale: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.viewLocale = action.payload;
      state.pendingStructuralEditor = undefined;
    },
    switchToPrimaryForStructuralEditor: (
      state,
      action: PayloadAction<string>
    ) => {
      state.viewLocale = undefined;
      state.pendingStructuralEditor = action.payload;
    },
    clearPendingStructuralEditor: (state) => {
      state.pendingStructuralEditor = undefined;
    },
  },
});

export const {
  setDesignerViewLocale,
  switchToPrimaryForStructuralEditor,
  clearPendingStructuralEditor,
} = designerLocaleSlice.actions;

export const selectDesignerViewLocale = (
  state: DefaultRootState
): string | undefined => state[designerLocaleSlice.name]?.viewLocale;

export const selectPendingStructuralEditor = (
  state: DefaultRootState
): string | undefined =>
  state[designerLocaleSlice.name]?.pendingStructuralEditor;
